export default "__VITE_ASSET__BnsfrzH4__"